function addStyle(selector, cssProp) {
  let valStr = ``;
  for (let key in cssProp) {
    valStr += `${key}: ${cssProp[key]} !important;`;
  }
  valStr = `{${valStr}}`;
  // console.log(`<style>${selector} ${valStr}</style>`);
  $(`<style>${selector} ${valStr}</style>`).appendTo("head");
}

export function allocateTheme(themeData) {
  // 将theme数据分配到Preivew中
  //***** common ****/
  // title
  addStyle("#main-title h2", {
    color: themeData.common.titleColor,
  });
  // step-title
  addStyle(".step-title h3", {
    color: themeData.common.subTitleColor,
  });
  // iconColor
  addStyle("#main-nav .tip-grid-col", {
    color: themeData.common.iconColor,
  });
  // next btn
  addStyle(".nextBtn-success", {
    "background-color": themeData.common.nextColor,
    "border-color": themeData.common.nextColor,
  });
  //***** size ****/
  // dot伪类颜色，通过动态插入style标签
  addStyle("#page-1 .step-title h3::after", {
    "background-color": themeData.size.dotColor,
  });
  // select size
  addStyle("#page-1 .radioButtonCol .active", {
    "background-color": themeData.size.btnBgColor,
    "border-color": themeData.size.btnBgColor,
  });

  //***** calendar ****/
  // dot伪类颜色，通过动态插入style标签
  addStyle("#page-2 .step-title h3::after", {
    "background-color": themeData.calendar.dotColor,
  });
  // panel bgcolor
  addStyle(".fc-header-toolbar ", {
    "background-color": themeData.calendar.panelBgColor,
  });
  addStyle(".fc-view-container .fc-head", {
    "background-color": themeData.calendar.panelBgColor,
  });
  // today  fc-today
  addStyle(".fc-today", {
    "background-color": themeData.calendar.todayBgColor,
  });
  // selected day
  addStyle(".selected-date", {
    "background-color": themeData.calendar.selectedBgColor,
  });
  //***** time ****/
  // dot
  addStyle("#page-3 .step-title h3::after", {
    "background-color": themeData.time.dotColor,
  });
  // small dot
  addStyle("#page-3 .tab.active a::after ", {
    "background-color": themeData.time.dotSmallColor,
  });
  // btn color
  addStyle("#page-3 .timeLabel.active", {
    "background-color": themeData.time.timeBtnColor,
    "border-color": themeData.time.timeBtnColor,
  });
  //***** customer ****/
  addStyle("#page-4 .step-title h3::after ", {
    "background-color": themeData.customer.dotColor,
  });
}



// WEBPACK FOOTER //
// ./src/utils/allocateTheme.js